// Home.js
import React from 'react';
import { Container, Box, Text, Heading } from '@chakra-ui/react';
import SearchSection from '../sections/SearchSection';
import { HousePricesSection } from '../sections/HousePricesSection';
import PlanningSection from '../sections/PlanningSection';
import { SearchResultsSection } from '../sections/SearchResultsSection';
import HomeSearchHistorySection from '../components/home/sections/HomeSearchHistorySection';

function Home() {
  return (
    <Box bg='brand.background' minH='100vh'>
      <Container maxW='container.xl' py={6}>
        <Box
          mb={8}
          p={6}
          borderRadius='md'
          bg='blue.50'
          borderLeft='4px'
          borderColor='blue.500'
          boxShadow='md'
        >
          <Heading size='md' mb={3} color='blue.700'>
            Property search
          </Heading>
          <Text>
            Search a UK address to view local house prices and planning applications.
          </Text>
        </Box>

        <HomeSearchHistorySection />
        <SearchSection />

        <SearchResultsSection>
          <HousePricesSection />
          <PlanningSection />
        </SearchResultsSection>
      </Container>
    </Box>
  );
}

export default Home;
